import React from 'react'
// libs
import styled from 'styled-components'
// components
import Skeleton from '@mui/material/Skeleton'

const SkeletonContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;
  margin-top: 8px;
  padding: 8px;
`

const SkeletonWrapper = styled.div`
  min-width: 200px;
  padding-right: 12px;
`

const RiskSkeleton: React.FC = () => {
  const loaderItemsCount = Math.floor(
    ((document.querySelector('.riskViewContainer') as HTMLElement)?.offsetWidth - 20) / 200
  )

  return (
    <SkeletonContainer>
      {[...Array(loaderItemsCount || 0).keys()].map((item) => (
        <SkeletonWrapper key={item}>
          <Skeleton variant='rounded' height={32} />
        </SkeletonWrapper>
      ))}
    </SkeletonContainer>
  )
}

export default RiskSkeleton
